import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';


import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollProgress from './components/ScrollProgress';
import LoadingPage from './components/LoadingPage';

// Pages
import Home from './pages/Home';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Ensure loading state is properly managed
    const handleLoad = () => {
      document.body.classList.remove('loading');
      document.documentElement.classList.add('loaded');
      setLoading(false);
    };

    // If already loaded
    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      setTimeout(() => setLoading(false), 4000); // fallback timeout
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);

  if (loading) return <LoadingPage />;

  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <div className="App">
        <ScrollProgress />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Footer />
      </div>
    </Router>
    
  );
}


export default App;
